//
// Copyright IBM Corp. 2020, 2020
//
// This source code is licensed under the Apache-2.0 license found in the
// LICENSE file in the root directory of this source tree.
//
import React from 'react';
import PropTypes from 'prop-types';
import { ErrorFilled16 } from '@carbon/icons-react';
import { idePrefix } from '../../globals/js/settings';

var IdeAutoSave = function IdeAutoSave(_ref) {
  var state = _ref.state,
      text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(idePrefix, "-auto-save")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(idePrefix, "-auto-save__icon")
  }, state === 'failed' && /*#__PURE__*/React.createElement(ErrorFilled16, {
    description: ""
  })), /*#__PURE__*/React.createElement("span", {
    className: "".concat(idePrefix, "-auto-save__text")
  }, text));
};

IdeAutoSave.defaultProps = {
  state: 'default',
  text: ''
};
IdeAutoSave.propTypes = {
  /** The current state to show */
  state: PropTypes.oneOf(['default', 'saving', 'saved', 'failed']).isRequired,

  /** The text to show for the current state. Must be pre-translated */
  text: PropTypes.string.isRequired
};
export default IdeAutoSave;